import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isAndroid, isMobileOnly } from 'react-device-detect';
import { get } from 'lodash-es';
import styled, { css } from 'styled-components';
import {
  CenterBox,
  DoconModal,
  DoconModalContent,
  Icons,
} from '@docon/docon-ui-library';
import { getPrescriptionPdf } from 'redux/reducer/prescription';
import OrderMedicine from './OrderMedicine';
import { Loader } from 'shared';
import { colors } from 'utilities/colorConfig';

const Modal = styled(DoconModal)`
  width: 95%;
  max-width: 666px;
  height: 100%;
  max-height: 80%;
  border-radius: 8px;
  overflow: hidden;
  position: relative;

  ${DoconModalContent} {
    max-height: initial;
    padding: 0;
    overflow: hidden;
  }

  ${Icons.DownloadIcon} {
    position: absolute;
    left: 15px;
    top: 15px;
  }

  > ${CenterBox} {
    z-index: 3;
    background-color: ${colors.white};
  }

  ${() => isMobileOnly && css`
    max-height: 95%;
  `}

  ${({ $isAndroid }) => $isAndroid && css`
    iframe {
      position: relative;
      z-index: -1;
    }
  `}
`;

function Prescription({
  hideOrderMedicine,
  visitID,
  doctorID,
  patientID,
  mobileNumber,
  source,
  onClose,
  ...props
}: any) {
  const iFrameRef = useRef<any>(null);
  const timerId = useRef<any>(null);
  const [isIframeLoading, setIsIframeLoading] = useState(true);
  const {
    prescriptionPdf: pdfUrl,
    isFetchingPrescriptionPdf,
  } = useSelector(state => state.prescription);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isFetchingPrescriptionPdf)
      dispatch(getPrescriptionPdf(`medical_data/prescriptions/get_rx_url/${visitID}/`));
  }, []);

  useEffect(() => {
    if (isAndroid && pdfUrl && isIframeLoading)
      timerId.current = setInterval(() => {
        const URL = get(iFrameRef, 'current.contentDocument.URL', null);
        if (URL == 'about:blank') {
          iFrameRef.current.src = `${iFrameRef.current.src}`;
        } else {
          clearInterval(timerId.current);
        }
      }, 3000);
  }, [pdfUrl]);

  function handleDownloadClick() {
    window.open(pdfUrl);
  }

  function handleLoad() {
    if (timerId)
      clearInterval(timerId.current);
    setIsIframeLoading(false);
  }

  return (
    <Modal
      centered
      hideFooter
      isOpen
      onClose={onClose}
      $isAndroid={isAndroid}
      {...props}
    >
      {
        isIframeLoading ? <Loader /> : null
      }
      {
        pdfUrl ? (
          <>
            <Icons.DownloadIcon hidden={!isMobileOnly} width={14} onClick={handleDownloadClick} />
            <iframe
              ref={iFrameRef}
              src={
                isAndroid ?
                  `https://docs.google.com/gview?url=${encodeURIComponent(pdfUrl)}&embedded=true` :
                  `${pdfUrl}#toolbar=${isMobileOnly ? 0 : 1}`
              }
              frameBorder='0'
              width='100%'
              height='100%'
              onLoad={handleLoad}
            />
          </>
        ) : null
      }

      {
        hideOrderMedicine ? null : (
          <OrderMedicine
            visitID={visitID}
            source={source}
            patientID={patientID}
            doctorID={doctorID}
            mobileNumber={mobileNumber}
          />
        )
      }
    </Modal>
  );
}

export default styled(Prescription)``;